import { BaseApiResponseModel } from "app/based/baseApiModel/baseApiResponseModel/BaseApiResponseModel";
import { injectable } from "tsyringe";
import { IConfigRepository } from "../domain/repositories/IConfigRepository";
import {
  FeaturedSideBarModel,
  SidebarMenuConfigModel,
} from "./models/SidebarMenuConfigModel";

@injectable()
export class SidebarMenuConfigRepository implements IConfigRepository {
  async getSidebarMenu(
    menuConfig: Array<FeaturedSideBarModel>,
  ): Promise<BaseApiResponseModel<SidebarMenuConfigModel>> {
    return Promise.resolve(
      new BaseApiResponseModel<SidebarMenuConfigModel>(
        undefined,
        new SidebarMenuConfigModel(menuConfig),
        undefined,
        undefined,
      ),
    );
  }
}
